<template>
	<v-dialog
		v-model="show"
		max-width="600"
		persistent
	>
		<template #activator="{ on }">
			<v-btn
				:disabled="uploadingImage"
				:loading="uploadingImage"
				outlined
				small
				v-on="on"
			>
				{{ activatorText }}
			</v-btn>
		</template>

		<v-card>
			<v-toolbar elevation="0">
				<v-file-input
					v-model="image"
					ref="imageInput"
					name="image"
					class="mt-6"
					outlined
					dense
					@change="handleImageSelected"
				/>
				<v-spacer />
				<v-btn
					outlined
					@click="show = false"
				>
					Отмена
				</v-btn>
			</v-toolbar>
			<v-card-text>
				<template v-if="cropperSrc">
					<div class="preview"></div>
					<vue-cropper
						ref="cropper"
						:src="cropperSrc"
						preview=".preview"
					/>
					<v-form
						ref="imageForm"
					>
						<input type="hidden" name="_method" value="PUT">
						<input type="hidden" name="add_watermark" :value="needsWatermark ? '1' : '0'">
						<v-checkbox
							v-model="needsWatermark"
							label="Добавить вотермарку?"
							false-value="0"
							true-value="1"
						/>
						<v-btn
							outlined
							color="green"
							class="mt-3"
							:disabled="uploadingImage"
							:loading="uploadingImage"
							@click="uploadImage"
						>
							Сохранить
						</v-btn>
					</v-form>
				</template>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
	name: 'UploadImageModal',
	components: {
		VueCropper,
	},
	props: {
		productId: {
			type: String,
			required: true,
		},
		activatorText: {
			type: String,
			default: 'Загрузить фото',
		},
	},
	data: () => ({
		image: null,
		cropperSrc: null,
		uploadingImage: false,
		needsWatermark: '1',
		show: false,
	}),
	computed: {
		inputElement() {
			return this.$refs.imageInput.$el.getElementsByTagName('input')[0];
		},
	},
	watch: {
		show(newValue) {
			if (newValue === true) {
				this.$nextTick(() => this.selectImage());
			}
		},
	},
	methods: {
		selectImage() {
			this.inputElement.click();
		},
		handleImageSelected(event) {
			console.debug('image selected', event);
			if (!!event) {
				this.initCropper();
			}
		},
		initCropper() {
			if (typeof FileReader === 'function') {
				const reader = new FileReader();
				reader.onload = (event) => {
					this.cropperSrc = event.target.result;
					// rebuild cropperjs with the updated source
					this.$nextTick(() => {
						this.$refs.cropper.replace(event.target.result);
					});
				};
				reader.readAsDataURL(this.image);
			} else {
				alert('Sorry, FileReader API not supported');
			}
		},

		async uploadImage() {
			if (this.uploadingImage || this.inputElement.files.length <= 0) {
				return;
			}
			this.$refs.cropper.getCroppedCanvas().toBlob(async (blob) => {
				this.uploadingImage = true;
				try {
					const formData = new FormData(this.$refs.imageForm.$el);
					formData.append('image', blob, 'image.png');
					const { data } = await this.$http.post(`/api/v1/products/${this.productId}`, formData);
					this.$notify(data.message);
					this.$emit('uploaded', data.product.media.images);
					this.show = false;
					this.image = null;
				} catch (e) {
					this.$notify.error('Ошибка');
					console.error(e);
				} finally {
					this.uploadingImage = false;
				}
			});
		},
	},
};
</script>

<style scoped>

</style>
